import React, {Fragment} from 'react';
import './AdminDashboardPageBody.scss';
import PageBodyWrapper from "root/PageBodyWrapper";
import DashboardContainer from "root/Dashboard/DashboardContainer";


const AdminDashboardPageBody = (props) =>
{
    return (
        <Fragment>
            <PageBodyWrapper title='Dashboard'>
            <div className='manage-grid-rows'></div>
                <DashboardContainer />
            </PageBodyWrapper>
        </Fragment>
    )

}

export default AdminDashboardPageBody;
